const COURIER_INTEGRATION_TYPES = [
  "dx",
  "dxBasic",
  "dxDropOff",
  "ups",
  "apc",
  "parcelforce",
] as const;

export type CourierIntegrationType = (typeof COURIER_INTEGRATION_TYPES)[number];

/**
 *
 * This function acts as a type guard, narrowing the type when used in conditionals.
 *
 * @param fulfillmentType - The fulfillment type to check
 * @returns true if the fulfillment type is a courier integration, false otherwise
 */
export const isCourierIntegrationFulfillmentType = (
  fulfillmentType?: string | null,
): fulfillmentType is CourierIntegrationType => {
  if (!fulfillmentType) return false;

  return COURIER_INTEGRATION_TYPES.includes(fulfillmentType);
};
